import { useOpMutation } from '../useOpMutation';

export const useGetErpLogin = () =>
  useOpMutation({
    apiEndpointName: 'getErpLogin',
  });
